import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { IUserInfo } from '../models/user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TrackingData } from './tracking';
import { UtilitiesProvider } from './utilities';
import { ENV } from '@app/env';
import * as firebase from 'firebase';
import moment from 'moment';
import { Observable } from 'rxjs';
import { _ACTIONS } from './analytics';

@Injectable()

export class CategoriesStaffData {

    fireAuth: any;
    clientId = ENV.client;

    constructor(
        public afAuth: AngularFireAuth,
        public database: AngularFireDatabase,
        public trackingData: TrackingData,
        private utilities: UtilitiesProvider,
        private http: HttpClient
    ) {
    }

    public getStaffsCategoriesByClientId(): any {
        return this.database.list<any>(`Clients/${this.clientId}/StaffCategories`).valueChanges();
    }

    public getCategoryDetail(id: string): any{
        return this.database.object<any>(`Clients/${this.clientId}/StaffCategories/${id}`).valueChanges();
    }
}



// WEBPACK FOOTER //
// ./src/providers/categories_staff.ts